<template>
  <div class="hello-vue-card">
    <div class="hello-vue-eyebrow">Vue Ready</div>
    <div class="hello-vue-title">{{ title }}</div>
    <div class="hello-vue-text">{{ message }}</div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: "Frontend mount is working"
  },
  message: {
    type: String,
    default: "You can now replace screen units with Vue components."
  }
})
</script>

<style scoped>
.hello-vue-card {
  padding: 14px 16px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(241, 245, 249, 0.95));
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.hello-vue-eyebrow {
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.hello-vue-title {
  margin-bottom: 4px;
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
}

.hello-vue-text {
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}
</style>
